export default __webpack_public_path__ + "static/media/back1.ae054931.jpg";